import { useContext, useEffect, useRef, useCallback } from "react";
import { UNSAFE_NavigationContext } from "react-router-dom";

export const useBlocker = (blocker, when = true) => {
  const navigator = useContext(UNSAFE_NavigationContext).navigator;
  const unblockRef = useRef(null);

  useEffect(() => {
    if (!when || typeof navigator.block !== "function") return;

    // Clean up existing blocker before re-registering
    if (unblockRef.current) {
      unblockRef.current();
    }

    unblockRef.current = navigator.block((tx) => {
      const autoUnblockingTx = {
        ...tx,
        retry() {
          unblockRef.current?.();
          tx.retry();
        },
      };

      blocker(autoUnblockingTx);
    });

    return () => {
      unblockRef.current?.();
      unblockRef.current = null;
    };
  }, [navigator, blocker, when]);
};

export const usePrompt = (message, when, onCancel) => {
  const blocker = useCallback(
    (tx) => {
      const confirmed = window.confirm(message);
      if (confirmed) {
        tx.retry(); // allow navigation
      } else {
        onCancel?.(); // you must set `when = false` from your component
      }
    },
    [message, onCancel]
  );

  useBlocker(blocker, when);
};
